import script from "./product3View.vue?vue&type=script&setup=true&lang=js"
export * from "./product3View.vue?vue&type=script&setup=true&lang=js"

import "./product3View.vue?vue&type=style&index=0&id=68cc2d58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68cc2d58"]])

export default __exports__